import { render } from "./OperatingHoursConfig.vue?vue&type=template&id=5bd07d5f&scoped=true&ts=true"
import script from "./OperatingHoursConfig.vue?vue&type=script&lang=ts"
export * from "./OperatingHoursConfig.vue?vue&type=script&lang=ts"

import "./OperatingHoursConfig.vue?vue&type=style&index=0&id=5bd07d5f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd07d5f"]])

export default __exports__